import { useFormik } from "formik";
import * as Yup from "yup";
import { format, isBefore } from "date-fns";
import { post } from "../../../api/util";
import { useMutation } from "@tanstack/react-query";
import { useState } from "react";

interface MarkerDoedResponse {
  afdoede: any;
  paavirkedeFirmaer: string[];
  paavirkedeFuldmaegtige: string[];
  paavirkedeKursushold: string[];
  paavirkedePrincipaler: string[];
}
export function useRegistrerDoedsfald(personId: string) {
  const [step, setStep] = useState(0);
  const [result, setResult] = useState<MarkerDoedResponse | null>(null);
  const { mutateAsync, isPending, error } = useMutation<
    MarkerDoedResponse,
    { data: string; status: number },
    any,
    any
  >({
    mutationFn: async (body: { doedDato: string }) => {
      return await post({
        query: `person/${personId}/wizards/markerdoed`,
        body: JSON.stringify(body),
      });
    },
  });

  const formik = useFormik<RegistrerDoedsfaldFormik>({
    validateOnMount: true,
    initialValues: {
      doedDato: undefined,
    },
    validationSchema: Yup.object({
      doedDato: Yup.date()
        .nullable()
        .required("Dato skal være sat")
        .test("doedDato", "Årstal skal være mindst 1900", (item) => {
          if (!item) return true;
          return item.getFullYear() > 1899;
        })
        .test("doedDato", "Må ikke være i fremtiden", (item) => {
          if (!item) return true;
          const date = new Date(item);
          return isBefore(date, new Date());
        }),
    }),
    onSubmit: async (values) => {
      const { doedDato } = values;
      const resp = await mutateAsync({
        doedDato: doedDato ? format(doedDato, "yyyy-MM-dd") : "",
      });
      setResult(resp);
      setStep(1);
    },
  });
  return { formik, isLoading: isPending, error, step, result };
}

export type RegistrerDoedsfaldFormik = {
  doedDato: Date | undefined;
};
